"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMobileLink = exports.ErrorMessageContainer = exports.TitleContainer = exports.PaymentPreferencePageUrlLinkContainer = exports.PaymentMethodSummaryContainer = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const utils_1 = require("../../utils");
const link_1 = require("../link");
exports.Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;
exports.PaymentMethodSummaryContainer = styled_components_1.default.div `
  margin-bottom: -5px;
`;
exports.PaymentPreferencePageUrlLinkContainer = styled_components_1.default.div `
  ${({ deviceType }) => (0, utils_1.isMobile)(deviceType)
    ? `        
      display: flex;
      align-items: center;
      justify-content: center;

      border: 1px solid ${monera_app_core_1.Gray_1400};
      border-radius: 4px;
      padding: 0 10px;
      background-color: ${monera_app_core_1.Gray_1600};
      `
    : `
    `}
`;
exports.TitleContainer = styled_components_1.default.div `
  font-weight: 700;
  font-size: 15px;
`;
exports.ErrorMessageContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  gap: 10px;
`;
exports.StyledMobileLink = (0, styled_components_1.default)(link_1.Link) `
  text-decoration: none;
  color: black !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  &:hover {
    text-decoration: none;
    color: black;
  }
`;
